function getLandingPage(layouts: any, pageId: string) {
  const layoutObj = Object.entries(layouts).find(([id, obj]): any => {
    return id === pageId && obj;
  });
  return layoutObj;
}

export { getLandingPage };
